/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import $ from 'jquery';
window.$ = window.jQuery = $;
window.tippy = require('tippy.js').default;
window.inputmask = require('inputmask/dist/jquery.inputmask.min').default;
window.magnificPopup = require('magnific-popup/dist/jquery.magnific-popup.min').default;

import 'jquery-ui/ui/widgets/datepicker.js';

// require('./bootstrap');
// require('magnific-popup');


tippy('[data-tippy-content]',{
    theme: 'tippy',
});


// window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });

$(document).ready(function () {

    function hideBody() {
        $('html, body').css('overflow', 'hidden');
    }

    function clearBodyStyle() {
        $('html, body').removeAttr('style');
    }

    function openModal(el) {
        $(el).show();
        hideBody();
    }

    function closeModal(el) {
        $(el).hide();
        clearBodyStyle();
    }

    $(document).on('click','.service__modal', function (e) {
        e.preventDefault();
        openModal('.modal');
    });

    $(document).on('click','.modal__header__close', function (e) {
        e.preventDefault();
        closeModal('.modal');
    });

    Inputmask("+7 (999) 999-99-99").mask('.phone-mask');
    Inputmask("A999AA999").mask('.government_number-mask');



    $('.popup-link').magnificPopup({
        type: 'image'
    });

    $(document).on('click','.faq__item', function (e) {
        e.preventDefault();

        var el = $(this);
        var id = el.data('id');

        $('.faq__answer').removeClass('faq__answer--active');
        $('.faq__answer').filter('[data-content="' + id + '"]').addClass('faq__answer--active');
    });

    $(document).on('click', '.nav__item-anchor, .hero__btn', function (e) {
        e.preventDefault();

        var id = $(this).attr('href'),
            top = $(id).offset().top;

        $('body,html').animate({scrollTop: top}, 1500);
    });

});
